import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { ApplicationState } from './application.state';

@NgModule({
  imports: [
    NgxsModule.forFeature([ ApplicationState ])
  ],
})
export class PartnerWebStoreApplicationModule {}
